import React from "react";

const HeroStart = () => {
  return (
    <div className='mini-hero-start'>
      <a href='#profile' className='hero-profile-scroll-icon'>
        <img src='/img/arrow_down.svg' alt='scroll to start' />
      </a>
    </div>
  );
};

export default HeroStart;
